__webpack_require__.p = "https://js-static.iimjobs.com/production/13.0.1/_next/";